// Constants.js

export const LOCATIONS = [
  { value: "Anywhere in India", label: "Anywhere in India" },
  { value: "bengaluru", label: "Bengaluru" },
  { value: "mumbai", label: "Mumbai" },
  { value: "delhi_ncr", label: "Delhi NCR" },
  { value: "hyderabad", label: "Hyderabad" },
  { value: "pune", label: "Pune" },
  { value: "chennai", label: "Chennai" },
]

export const LOCATION_SHORT = {

  bengaluru: "BLR",
  mumbai: "MUM",
  delhi_ncr: "DEL",
  hyderabad: "HYD",
  pune: "PNE",
  chennai: "CHN",
}

export const JOB_FAMILIES = [
  { key: "SWE",    name: "Software Engineering",         desc: "Backend, frontend, fullstack" },
  { key: "ML",     name: "ML / AI",                      desc: "Machine learning & AI systems" },
  { key: "DATA",   name: "Data",                         desc: "Pipelines, analytics, BI" },
  { key: "INFRA",  name: "Platform / Infrastructure",    desc: "Cloud, reliability, DevOps" },
  { key: "MOBILE", name: "Mobile",                       desc: "iOS, Android, cross-platform" },
  { key: "SYS",    name: "Embedded / Systems",           desc: "Low-level, hardware-adjacent" },
  { key: "SEC",    name: "Security",                     desc: "AppSec, infra security" },
  { key: "QA",     name: "QA / Testing",                 desc: "Manual & automated testing" },
  { key: "PM",     name: "Product Management",           desc: "Strategy, roadmap, requirements" },
  { key: "PROG",   name: "Program / Project Mgmt",       desc: "Delivery & cross-team alignment" },
  { key: "DESIGN", name: "Design",                       desc: "UX, UI, design systems" },
  { key: "EM",     name: "Engineering Management",       desc: "People & technical leadership" },
  { key: "SOL",    name: "Solutions & Support",          desc: "Customer-facing, implementation" },
  { key: "IT",     name: "IT & Operations",              desc: "Internal IT, networking, DBAs" },
]

export const SENIORITY_LEVELS = [
  { key: "INTERN",    label: "Intern",     desc: "Temporary / trainee roles" },
  { key: "ENTRY",     label: "Entry",      desc: "Junior, Associate, New Grad" },
  { key: "MID",       label: "Mid",        desc: "SDE II, L4 — independent contributor" },
  { key: "SENIOR",    label: "Senior",     desc: "Senior, Sr, L5" },
  { key: "STAFF",     label: "Staff",      desc: "Staff, Tech Lead, L6" },
  { key: "PRINCIPAL", label: "Principal",  desc: "Principal, L7" },
  { key: "EXECUTIVE", label: "Executive",  desc: "Director, VP, Head of, CTO" },
]

export const COMPANIES = [
  { key: "google", name: "Google", logo: null },
]